
const common={
    api: {
        packageList:"/api/package/lst",
        projectList:"/api/project/lst",
        upProject:"/api/project/upinfo",
        upPackage:"/api/package/upinfo",

        login:"/api/login/login",
        register:"/api/login/registerRelease",
        sendCode:"/api/login/sendEmailCode",
        forget:"",
        quit:"/api/project/quit"
    },

    tost (msg,err){

        var str="<div class='shici-tost' style='position:fixed;width:100%;height:80px;background:#dff0d8;z-index:99999;top:0px;color:#3c763d;text-align:center;font-size:28px;padding-top:20px'>";
        str+=msg;
        str+="</div>";
        $("body").append(str);
        setTimeout(function(){
            $(".shici-tost").animate({'height':'0px','padding':"0px"},500,function(){
                $(this).remove();
            });
        },2000)
    
    },

    // 分页
    pagehtml(total,page,size){
        var str = "";
        if(total<=size){
            return str;
        }

        var totalpage = Math.ceil(total/size);

        var st = page-3;
        var en = page+3;
        
        
        str+='<nav aria-label="Page navigation"><ul class="pagination">';

        if(st<1){
            en = en-st;
        }
        if((page+3)>totalpage){
            st=st-(page+3-totalpage);
        }
        for (var i = 1; i <=totalpage; i++) {
            if(i==1 && page>1){
                str+='<li onclick="turnpage('+(page-1)+')">\
                <a href="javascript:;" aria-label="Previous">\
                <span aria-hidden="true">&laquo;</span>\
                </a>\
                </li>';
            }
            if(st>1 && i==1){
                str+='<li onclick="turnpage(1)" page="1"><a href="javascript:;">1</a></li>';  
                if(st>2){
                str+='<li><a href="javascript:;">…</a></li>';  
                }
                
            }
            if(i>=st && i<=en){
                if(i==page){
                    str+='<li onclick="turnpage('+i+')" page="'+i+'" class="active"><a href="javascript:;">'+i+'</a></li>';
                }else{
                    str+='<li onclick="turnpage('+i+')" page="'+i+'"><a href="javascript:;">'+i+'</a></li>';   
                }
                
            }

            if(en<totalpage && i==totalpage){
                if(en<(totalpage-1)){
                    str+='<li><a href="javascript:;">…</a></li>';
                }
                str+='<li onclick="turnpage('+totalpage+')" page="'+totalpage+'"><a href="javascript:;">'+totalpage+'</a></li>';  
            }

            if(i==totalpage && page<totalpage){
                str+= '<li onclick="turnpage('+(page+1)+')">\
                <a href="#" aria-label="Next">\
                <span aria-hidden="true">&raquo;</span>\
                </a>\
                </li>';
            }
        }

        str+='</ul></nav>';
        return str;

    },

    // 检测邮箱格式
    checkemail:function(email){
       
        if(!email.match(/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/)){
          
            return false;
        }else{
            return true;
        }
    },

    checkphone(phone){
        if(!phone.match(/^[1][3|4|5|7|8|9][0-9]{9}$/)){
            return false;
        }else{
            return true;
        }
    }
    

}

export default common


// WEBPACK FOOTER //
// ./src/common/index.js